<template>
  <div class="view-sticky-footer">
    <cms-sticky-footer
      v-if="stickyFooterSetUp"
      :theme="stickyFooterOptions"
      :content="homepage.sticky_footer"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useMainStore } from '../../../stores/mainStore.js';
import { useTranslationStore } from '../../../stores/translationStore.js';

const mainStore = useMainStore();
const translationStore = useTranslationStore();

const theme = computed(() => mainStore.theme);
const homepage = computed(() => mainStore.homepage);

const stickyFooterOptions = computed(() => ({
  ...theme.value.sticky_footer.options,
  translations: translationStore.getComponentTranslation('sticky_footer'),
  globalThemeSettings: mainStore.getGlobalThemeSettings,
}));

const stickyFooterSetUp = computed(
  () => homepage.value?.sticky_footer?.pill_button || homepage.value?.sticky_footer?.icon_buttons,
);
</script>
